<h2 mat-dialog-title>
  {{ data.title | translate: { param1: data.paramTitle?.param1 ?? '', param2: data.paramTitle?.param2 ?? '', param3:
  data.paramTitle?.param3 ?? '' } }}
</h2>

<div mat-dialog-content>
  {{ data.message | translate:{ param1: data.paramMessage?.param1 ?? '', param2: data.paramMessage?.param2 ?? '',
  param3: data.paramMessage?.param3 ?? '' } }}
</div>

<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">
    {{ data.cancelText | translate }}
  </button>

  <button mat-raised-button color="primary" [mat-dialog-close]="true">
    {{ data.confirmText | translate }}
  </button>
</div>